<cb-table
    class="cb-margin-top"
    label="Supply Types"
    [objectColumns]="columns"
    [loaded]="loaded"
    [minWidth]="1000"
    [maxHeightOffset]="271"
>
    <tbody cbTableBody>
        @for (supplyType of orderSupplyTypes(supplyTypes); track supplyType) {
            <tr>
                <td>
                    @if (supplyType.mappedChildren?.length > 0) {
                        <button
                            mat-icon-button
                            (click)="expanded[supplyType.id] = !expanded[supplyType.id]"
                        >
                            <mat-icon>
                                {{ expanded[supplyType.id] ? 'arrow_drop_up' : 'arrow_drop_down' }}
                            </mat-icon>
                        </button>
                    }
                </td>
                <td>
                    {{ supplyType.label }}
                    @if (!supplyType.isActive) {
                        <span> &nbsp;(Inactive) </span>
                    }
                </td>
                <td>-</td>
                <cb-td-checkbox [value]="supplyType.isActive"></cb-td-checkbox>
                <td cbTableStickyCol="end" cbTableShrinkCol>
                    <button
                        mat-icon-button
                        (click)="editSupplyType(supplyType)"
                        [disabled]="!permissions?.canEdit()"
                    >
                        <mat-icon> edit </mat-icon>
                    </button>
                </td>
            </tr>
            @if (expanded[supplyType.id]) {
                @for (child of orderSupplyTypes(supplyType?.filteredChildren); track child) {
                    <tr class="child">
                        <td></td>
                        <td class="childLabel">
                            {{ child.label }}
                        </td>
                        @if (child.requiredComplianceRegistrations.length > 0) {
                            <td>
                                <ul class="inline-list">
                                    @for (
                                        complianceReg of child.requiredComplianceRegistrations;
                                        track complianceReg
                                    ) {
                                        <li>
                                            {{ complianceReg.label }}
                                        </li>
                                    }
                                </ul>
                            </td>
                        }
                        @if (child.requiredComplianceRegistrations.length < 1) {
                            <td>-</td>
                        }
                        <cb-td-checkbox [value]="child.isActive"></cb-td-checkbox>
                        <td cbTableStickyCol="end" cbTableShrinkCol>
                            <button mat-icon-button (click)="editSupplyType(child)">
                                <mat-icon> edit </mat-icon>
                            </button>
                        </td>
                    </tr>
                }
            }
        }
    </tbody>
</cb-table>
